import { StateCreator } from "zustand";

import { FriendData, FriendRequest } from "api/friend";
import { GetUserById } from "api/profile";
import { VoteByEventId } from "api/vote";
import { EventRow } from "api/event";
import { GetAllGroups } from "api/group";

export interface AugmentedEvent extends EventRow {
  stale: boolean;
}

export interface AugmentedGroup extends GetAllGroups {
  stale: boolean;
}

export interface AppData {
  events: AugmentedEvent[];
  friends: FriendData[];
  friendRequests: FriendRequest[];
  groups: AugmentedGroup[];
  groupsUsers: GetUserById[];
  initialized: boolean;
  isLoading: boolean;
  isSyncing: boolean;
  isStale: boolean;
  staleFriendsAndRequests: boolean;
  staleGroupsAndFriendRequests: boolean;
  storedInLocalStorage: boolean;
  votes: VoteByEventId[];
  set: (props: Partial<AppDataSlice["appData"]>) => void;
}

export interface AppDataSlice {
  appData: AppData;
}

const createAppDataSlice: StateCreator<AppDataSlice, [], [], AppDataSlice> = (set) => ({
  appData: {
    events: [],
    friends: [],
    friendRequests: [],
    groups: [],
    groupsUsers: [],
    initialized: false,
    isLoading: false,
    isSyncing: false,
    isStale: false,
    staleFriendsAndRequests: false,
    staleGroupsAndFriendRequests: false,
    storedInLocalStorage: false,
    votes: [],
    set: (props) => set((state) => ({ appData: { ...state.appData, ...props } })),
  },
});

export default createAppDataSlice;
